import { Clipboard } from '@angular/cdk/clipboard'
import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, ViewChild } from '@angular/core'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { QrcodeComponent } from '@app/modules/shared/components/qrcode/qrcode.component'
import { environment } from '@environments/environment'
import { ISocial } from '../../../model/social-media.model'
@Component({
  selector: 'ngx-landing-share',
  templateUrl: './landing-share.component.html',
  styleUrls: ['./landing-share.component.scss'],
  imports: [CommonModule, QrcodeComponent]
})
export class LandingShareComponent implements OnDestroy, AfterViewInit {
  @Input() eventSlug = ''
  @Input() formSlug = ''

  socials: ISocial[] = [
    // Details for each social media platform
    { url: 'https://telegram.me/share/url', icon: 'https://library.micetribe.com/icons/telegram.svg', title: 'Telegram' },
    { url: 'https://wa.me/?text=', icon: 'https://library.micetribe.com/icons/whatsapp.svg', title: 'WhatsApp' },
    { url: 'https://x.com/intent/tweet?url=', icon: 'https://library.micetribe.com/icons/twitter(x).svg', title: 'X' },
    { url: 'https://www.linkedin.com/shareArticle?url=', icon: 'https://library.micetribe.com/icons/linkedin.svg', title: 'Linkedin' },
    { url: 'https://www.facebook.com/sharer/sharer.php?u=', icon: 'https://library.micetribe.com/icons/facebook.svg', title: 'Facebook' }
  ]
  formLinkStatus: string
  mirrorLinkStatus: string[] = []
  isCopying = false
  showIcons = false
  // QR code details
  qrCodeTagId = 'qrcode'
  format = 'svg'
  qrBackgroundColor = '#fff'
  private _intersectionObserver: IntersectionObserver

  // Reference to the share button element
  @ViewChild('menuId') menuElement: ElementRef
  // Listener for clicks outside of the share button, to close the social icons
  @HostListener('document:touchmove')
  closeShareDialog() {
    this.showIcons = false
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (!this.menuElement?.nativeElement.contains(event.target)) {
      this.showIcons = false
    }
  }
  constructor(
    private clipboard: Clipboard,
    private auth: AuthService
  ) {}

  ngAfterViewInit(): void {
    const options = {
      rootMargin: '0px',
      threshold: 1.0
    }
    this._intersectionObserver = new IntersectionObserver(() => (this.showIcons = false), options)
    if (document.querySelector('ngx-landing-previewer')) {
      this._intersectionObserver.observe(document.querySelector('ngx-landing-previewer'))
    }
  }

  ngOnDestroy(): void {
    this._intersectionObserver.disconnect()
  }

  /**
   * @param event Mouse event
   */
  showShareIcons(event: MouseEvent) {
    if (event.target === this.menuElement.nativeElement || event.target instanceof HTMLImageElement || event.target instanceof HTMLSpanElement) {
      this.showIcons = !this.showIcons // Toggle the showIcons property
    }
    event.stopPropagation()
  }

  /**
   * Copy code and toggle status display
   * @param value string
   * @param index number
   * @returns void
   */
  copyCode(value?: string, index?: number): void {
    if (this.isCopying) return
    this.isCopying = true
    this.formLinkStatus = 'Copied to Clipboard'
    this.clipboard.copy(this.formLink)
    setTimeout(() => {
      this.formLinkStatus = undefined
      this.isCopying = false
      window.open(this.formLink, '_blank')
    }, 500)
  }

  /**
   * Get form link
   * @returns string
   */
  get formLink(): string {
    return `${environment.landingPageUrl}workspaces/${this.auth.currentWorkspace.slug}/events/${this.eventSlug}/forms/${this.formSlug}?focus=false`
  }

  /**
   * Get share url for a social media platform
   * @param social ISocial
   * @returns string
   */
  getShareUrl(social: ISocial): string {
    return `${social.url}${encodeURIComponent(this.formLink)}`
  }
}
